import {combineReducers} from '@reduxjs/toolkit';

import {bulkActionsLogStateSlice} from './slices/user-activity-log-state.slice';
import {bulkActionsLogSlice} from './slices/user-activity-log.slice';

export const userActivityLogsReducer = combineReducers({
    result: bulkActionsLogSlice.reducer,
    state: bulkActionsLogStateSlice.reducer,
});
